<mat-card class="mcd-card" *ngIf="!loading">
  <mat-card-content class="mcd-card-content">
    <div class="supplier-detail-container">
      
      <!-- Top Action Bar -->
      <div class="top-action-bar">
        <button class="btn-back" (click)="goBack()">
          <i class="material-icons">arrow_back</i>
          Back
        </button>
        <div class="page-header-title">
          <span class="header-icon material-icons">storefront</span>
          <span class="header-text">Market Supplier Details</span>
        </div>
      </div>

      <!-- Main Supplier Card Wrapper -->
      <div class="supplier-card-main">
        <!-- Breadcrumb & Edit/Delete Actions -->
        <div class="supplier-card-header">
          <div class="breadcrumb-trail">
            Admin / Market Suppliers / {{ supplier.name }}
          </div>
          <div class="action-buttons-group">
            <button class="btn-action-outline btn-edit" (click)="onEdit()">
              <i class="material-icons">edit</i>
              Edit
            </button>
            <button class="btn-action-outline btn-delete" (click)="openDeleteModal()">
              <i class="material-icons">delete_outline</i>
              Delete
            </button>
          </div>
        </div>

        <!-- Supplier Logo & Info Box -->
        <div class="supplier-info-block">
          <div class="supplier-logo-wrapper" *ngIf="supplier?.supplierLogoAttachment?.image">
            <img [src]="supplier.supplierLogoAttachment.image" [alt]="supplier.name" class="supplier-logo-img" />
          </div>
          <h1 class="supplier-name-title">{{ supplier.name }}</h1>
          <p class="supplier-description-text" *ngIf="supplier.description">
            {{ supplier.description }}
          </p>

          <!-- Markets Assigned Row -->
          <div class="markets-assigned-row">
            <span class="market-icon material-icons">storefront</span>
            <span class="markets-label">Markets Assigned</span>
            <span class="markets-value">{{ getFormattedMarkets() }}</span>
          </div>
        </div>

        <!-- Connected Equipment Carousel Section -->
        <div class="details-section equipment-section-card">
          <div class="details-header" (click)="toggleEquipment()">
            <div class="details-title-wrapper">
              <div>
                <span class="toggle-icon">
                  <img
                    *ngIf="!equipmentExpanded"
                    src="../../assets/images/s-add 1.svg"
                    alt="Expand"
                    style="margin-bottom: 3px; cursor: pointer" />
                  <img
                    *ngIf="equipmentExpanded"
                    src="../../assets/images/cross (2).svg"
                    alt="Collapse"
                    style="margin-bottom: 3px; cursor: pointer"
                /></span>
                <span class="details-title" [ngClass]="{ 'details-title-expanded': equipmentExpanded }">
                  Equipment
                </span>
              </div>
            </div>
          </div>

          <!-- Carousel Container -->
          <div 
            class="details-content equipment-carousel-wrapper" 
            [class.expanded]="equipmentExpanded"
          >
            <div *ngIf="supplier.equipments && supplier.equipments.length > 0">
              <owl-carousel-o [options]="customOptions">
                <ng-template carouselSlide *ngFor="let item of supplier.equipments">
                  <div 
                    class="equipment-card" 
                    (click)="viewEquipmentDetail(item)"
                  >
                    <h3 class="eq-card-title">{{ item.title }}</h3>
                    
                    <div class="eq-badges-row">
                      <span class="eq-badge" *ngIf="item.model">
                        <i class="material-icons badge-icon">dns</i>
                        {{ item.model }}
                      </span>
                      <span class="eq-badge" *ngIf="item.effectiveFrom || item.obsoleteDate">
                        <i class="material-icons badge-icon">calendar_today</i>
                        {{ (item.effectiveFrom || item.obsoleteDate) | date: 'dd, MMM yyyy' }}
                      </span>
                    </div>

                    <div class="eq-image-box">
                      <img 
                        *ngIf="item.imageAttachment?.image" 
                        [src]="item.imageAttachment.image" 
                        [alt]="item.title" 
                        class="eq-image" 
                      />
                      <div *ngIf="!item.imageAttachment?.image" class="eq-image-placeholder">
                        <i class="material-icons">build</i>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </owl-carousel-o>
            </div>

            <!-- Empty Equipment State -->
            <div class="empty-equipment-state" *ngIf="!supplier.equipments || supplier.equipments.length === 0">
              <p>No equipment standards associated with this market supplier.</p>
            </div>
          </div>
        </div>

      </div>

    </div>
  </mat-card-content>
</mat-card>

<app-mcd-loader *ngIf="loading"></app-mcd-loader>
